import React, { useContext, useState } from "react";
import styled from "styled-components";
import eventBus from '../../utils/globalPubSub';

import {
    useHistory,
} from "react-router-dom";


import { PaymentContext } from "../../utils/paymentConfigProvider";
import StreamPowerImageComponent from "../../components/StreamPowerComponents/StreamImageComponent";
import {claimFreePerk} from "../../utils/perksUtils";

import autograph from '../../assets/powers/autograph.png';

const PurpleButton = styled.div`
  font-family: 'Chakra Petch';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  padding: 10px;
  position: relative;
  z-index: 1;
  background: #650054;
  border-radius: 12px;
`;


const PowersTitle = styled.div`
  font-family: 'Chakra Petch';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 90.1%;
  /* or 18px */

  text-align: center;

  color: #FFFFFF;
  margin-top: 8px;
`;


export default function PowersListComponent(props) {
    const history = useHistory();


    const paymentConfig:any = useContext(PaymentContext);
    const [perkClaimLoader, setPerkClaimLoader] = useState(false);
    
    const checkIsIndiaPayment = (paymentConfig)=>{
        if(!paymentConfig){
            return false;
        }
        if(!paymentConfig.creatorConfig){
            return false;
        }
        if(!paymentConfig.creatorConfig.config){
            return false
        }
        if(paymentConfig.creatorConfig.config.acceptedCurrencies.includes('INR')){
            return true;
        }
    }
    const isIndiaPayment = checkIsIndiaPayment(paymentConfig);

    let currencyString ='$';
    if(isIndiaPayment){
        currencyString = `\u20B9`;
    }
    
    const claimPerk = async (claimPerkItem:any) => {
        setPerkClaimLoader(true);
        eventBus.dispatch("show-login-connection-modal");
        let resp:any = await claimFreePerk(claimPerkItem._id);
        if(resp && resp.data && resp.data.success){
            console.log('free-perk-claimed');
            eventBus.dispatch('free-perk-claimed')
        }
        setPerkClaimLoader(false);
    }

    const usePower = (perkItem:any) => {
        let ownedPower = props.ownedPerksDict[perkItem.id];
        console.log('ownedPower', ownedPower);
        history.push({
            pathname: `/power/${ownedPower._id}`,
            state: {power: perkItem}})
    };
    
    const handleOnClick = (perkItem:any, parentItem:any) => {
        if(perkItem.id in props.ownedPerksDict){
            return usePower(perkItem);
        }
        if(props.free){    
            return claimPerk(parentItem);
        }
        history.push({
            pathname: `/store/${props.username}/${perkItem.id}`,
            state: {power: perkItem}})
        window.scrollTo(0,0)
    }
    
    const powerList = props.powers.map((item, index) => {

        let perkItem:any = item;
        let claimed:boolean = false;
        if(props.free){
            perkItem = item.perkData
            claimed = item.claimed;
        }

        let isOwned:boolean = perkItem.id in props.ownedPerksDict;
        return (
            <div
                key={`power-${index}`}
                className="hover"
                onClick={()=> handleOnClick(perkItem, item)}
                style={{
                    background: `url('${autograph}')`,
                    marginLeft: 20,
                    width: 190,
                    height: 270,
                    display: 'flex',
                    justifyContent: 'flex-start',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginBottom: 20,
                }} >
                <div style={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center', height: '100%'}}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                        {/* <PowersStock>8 items in stock</PowersStock> */}
                        <br></br>
                        <PowersTitle>{perkItem.name}</PowersTitle>
                        <StreamPowerImageComponent
                            powerType={perkItem.data.type}
                            url={perkItem.imageUri}
                            >
                        </StreamPowerImageComponent>
                    </div>
                    {(isOwned) && (
                        <PurpleButton className="hover">
                            Use Power
                        </PurpleButton>
                    )}
                    {(!(isOwned) && (
                        !props.free)) && (
                            <PurpleButton className="hover">
                                BUY {currencyString}{item.data.price}
                            </PurpleButton>
                    )}
                    {(!isOwned && props.free && !claimed) && (
                        <PurpleButton className="hover">
                            Claim Perk
                        </PurpleButton>
                    )}
                    {(!isOwned && props.free && claimed) && (
                        <PurpleButton className="hover">
                            Perk Already Claimed
                        </PurpleButton>
                    )}
                </div>
            </div>
        );
    });
    return (<>{powerList}</>);
}
